import { defineMessages } from 'react-intl'

const scope = `procurify.platform.finance.components.AccountSelect`

export default defineMessages({
  placeholderText: {
    id: `${scope}.placeholderText`,
    defaultMessage: 'Select an account code',
  },
})
